/**
 * 수정용 config
 */
let transactionConfig = {
  sso: {
    insert: {
      url: '/api/auth/sso',
    },
  },
  auth: {
    login: {
      insert: {
        url: '/api/auth/login',
      },
      logout: {
        url: '/api/auth/logout',
      },
      update: {
        url: '/api/auth/logout/{0}',
      },
      changepw: {
        url: '/api/auth/user/changepw',
      },
      nextChangePw: {
        url: '/api/auth/user/nextChangePw',
      },
    },
  },
  com: {
    upload: {
      uploading: {
        url: "/api/com/upload"
      },
      save: {
        url: "/api/com/update/taskKey"
      },
      delete: {
        url: "/api/com/upload/{0}"
      },
      allDelete: {
        url: "/api/com/upload/all/{0}/{1}"
      },
      copy: {
        url: "/api/com/upload/copy"
      },
    },
    comments: {
      insert: {
        url: "/api/com/comments"
      },
      update: {
        url: "/api/com/comments"
      },
      delete: {
        url: "/api/com/comments/{0}",
        task: {
          url: "/api/com/comments/{0}/{1}"

        }
      },
    },
  },
  sys: {
    appr: {
      type: {
        insert: {
          url: '/api/sys/appr/type',
        },
        update: {
          url: '/api/sys/appr/type',
        },
        delete: {
          url: '/api/sys/appr/type/{0}',
        },
      },
      request: {
        insert: {
          url: '/api/sys/appr/request',
        },
        update: {
          url: '/api/sys/appr/request',
        },
        return: {
          url: '/api/sys/appr/request/return',
        },
        retrieve: {
          url: '/api/sys/appr/request/retrieve/{0}',
        }
      },
    },
    log: {
      menulog: {
        insert: {
          url: "/api/sys/log/menulog"
        },
      }
    },
    favorite: {
      save: {
        url: "/api/sys/favorites"
      },
      insert: {
        url: "/api/sys/favorite"
      },
      delete: {
        url: "/api/sys/favorite"
      },
    },
    menu: {
      insert: {
        url: '/api/sys/men/menu',
      },
      update: {
        url: '/api/sys/men/menu',
      },
      delete: {
        url: '/api/sys/men/menu/{0}',
      },
    },
    manual: {
      insert: {
        url: '/api/sys/men/manual',
      },
      update: {
        url: '/api/sys/men/manual',
      },
    },
    sequence: {
      insert: {
        url: '/api/sys/sequence',
      },
      update: {
        url: '/api/sys/sequence',
      },
      delete: {
        url: '/api/sys/sequence/{0}',
      },
    },
    attach: {
      insert: {
        url: '/api/sys/attachsetting',
      },
      update: {
        url: '/api/sys/attachsetting',
      },
      delete: {
        url: '/api/sys/attachsetting/{0}',
      },
    },
    excelUpload: {
      insert: {
        url: '/api/sys/excelUploadSetting',
      },
      update: {
        url: '/api/sys/excelUploadSetting',
      },
    },
    batch: {
      insert: {
        url: '/api/sys/batchsetting',
      },
      update: {
        url: '/api/sys/batchsetting',
      },
      delete: {
        url: '/api/sys/batchsetting/{0}',
      },
    },
    env: {
      insert: {
        url: '/api/sys/env',
      },
      update: {
        url: '/api/sys/env',
      },
      delete: {
        url: '/api/sys/env/{0}',
      },
    },
    shortcut: {
      insert: {
        url: '/api/sys/shortcut',
      },
      update: {
        url: '/api/sys/shortcut',
      },
      delete: {
        url: '/api/sys/shortcut/{0}',
      },
    },
    notice: {
      insert: {
        url: '/api/sys/notice',
      },
      update: {
        url: '/api/sys/notice',
      },
      delete: {
        url: '/api/sys/notice/{0}',
      },
    },
    defect: {
      insert: {
        url: '/api/sys/defect',
      },
      update: {
        url: '/api/sys/defect',
      },
      delete: {
        url: '/api/sys/defect/{0}',
      },
    },
    code: {
      domain: {
        save: {
          url: "/api/sys/code/domain"
        },
        delete: {
          url: "/api/sys/code/domain"
        }
      },
      group: {
        save: {
          url: "/api/sys/code/grp"
        },
        delete: {
          url: "/api/sys/code/grp"
        }
      },
      mst: {
        save: {
          url: "/api/sys/code/mst"
        },
        delete: {
          url: "/api/sys/code/mst"
        }
      }
    },
    stepper: {
      grp: {
        save: {
          url: "/api/sys/stepper/grp"
        },
        delete: {
          url: "/api/sys/stepper/grp"
        }
      },
      mst: {
        save: {
          url: "/api/sys/stepper/mst"
        },
        delete: {
          url: "/api/sys/stepper/mst"
        }
      }
    },
    lbl: {
      mst: {
        save: {
          url: "/api/sys/label/mst"
        },
        delete: {
          url: "/api/sys/label/mst"
        }
      },
      dtl: {
        insert: {
          url: '/api/sys/label/dtl',
        },
        update: {
          url: '/api/sys/label/dtl',
        },
        delete: {
          url: '/api/sys/label/dtl/{0}',
        },
      }
    },
    msg: {
      mst: {
        save: {
          url: "/api/sys/msg/mst"
        },
        delete: {
          url: "/api/sys/msg/mst"
        }
      },
      dtl: {
        insert: {
          url: '/api/sys/msg/dtl',
        },
        update: {
          url: '/api/sys/msg/dtl',
        },
        delete: {
          url: '/api/sys/msg/dtl/{0}',
        },
      }
    },
    auth: {
      grp: {
        insert: {
          url: '/api/sys/auth/grp',
        },
        update: {
          url: '/api/sys/auth/grp',
        },
        delete: {
          url: '/api/sys/auth/grp/{0}',
        },
      },
      menu: {
        add: {
          url: '/api/sys/auth/menu/add',
        },
        save: {
          url: '/api/sys/auth/menu',
        },
        delete: {
          url: '/api/sys/auth/menu',
        },
      },
      dept: {
        insert: {
          url: '/api/sys/auth/dept',
        },
        delete: {
          url: '/api/sys/auth/dept',
        },
      },
      user: {
        insert: {
          url: '/api/sys/auth/user',
        },
        delete: {
          url: '/api/sys/auth/user',
        },
      },
      deptauth: {
        insert: {
          url: '/api/sys/auth/deptauth',
        },
        delete: {
          url: '/api/sys/auth/deptauth',
        },
      },
      userauth: {
        insert: {
          url: '/api/sys/auth/userauth',
        },
        delete: {
          url: '/api/sys/auth/userauth',
        },
      },
      plant: {
        insert: {
          url: '/api/sys/auth/plant',
        },
      },
    },
  },
  ram: {
    variable: {
      insert: {
        url: "/api/ram/base/variable"
      },
      update: {
        url: "/api/ram/base/variable"
      },
    },
    matrix: {
      insert: {
        url: "/api/ram/base/matrix"
      },
      update: {
        url: "/api/ram/base/matrix"
      },
    },
    riskType: {
      insert: {
        url: "/api/ram/base/riskType"
      },
      update: {
        url: "/api/ram/base/riskType"
      },
    },
    riskHazard: {
      update: {
        url: "/api/ram/base/riskHazard"
      },
    },
    fmRiskHazard: {
      save: {
        url: "/api/ram/base/4mRiskHazard"
      },
    },
    assessPlan: {
      insert: {
        url: "/api/ram/assess/plan"
      },
      update: {
        url: "/api/ram/assess/plan"
      },
      delete: {
        url: "/api/ram/assess/plan/{0}",
        auth: {
          url: "/api/ram/assess/plan/auth"
        },
      },
      complete: {
        url: "/api/ram/assess/plan/complete"
      },
      request: {
        url: "/api/ram/assess/plan/request"
      },
      return: {
        url: "/api/ram/assess/plan/return"
      },
      load: {
        url: "/api/ram/assess/plan/load/{0}"
      },
    },
    assessTeam: {
      update: {
        url: "/api/ram/assess/team"
      },
      delete: {
        url: "/api/ram/assess/team"
      },
    },
    assessConference: {
      update: {
        url: "/api/ram/assess/conference"
      },
      delete: {
        url: "/api/ram/assess/conference"
      },
    },
    relatedDocument: {
      update: {
        url: "/api/ram/assess/relatedDocument"
      },
      delete: {
        url: "/api/ram/assess/relatedDocument"
      },
    },
    assessProcess: {
      insert: {
        url: "/api/ram/assess/process"
      },
      update: {
        url: "/api/ram/assess/process"
      },
      delete: {
        url: "/api/ram/assess/process"
      },
      estimation: {
        url: "/api/ram/assess/process/estimation"
      },
      estimationComplete: {
        url: "/api/ram/assess/process/estimation/complete"
      },
      complete: {
        url: "/api/ram/assess/process/complete"
      },
      checklist: {
        insert: {
          url: "/api/ram/checklist/assess/process"
        },
        update: {
          url: "/api/ram/checklist/assess/process"
        },
        delete: {
          url: "/api/ram/checklist/assess/process"
        },
        complete: {
          url: "/api/ram/checklist/assess/process/complete"
        },
      }
    },
    drawNode: {
      save: {
        url: "/api/ram/assess/draw"
      },
      delete: {
        url: "/api/ram/assess/draw"
      },
    },
    assessSop: {
      save: {
        url: "/api/ram/assess/sop"
      },
      delete: {
        url: "/api/ram/assess/sop"
      },
    },
    riskRegister: {
      delete: {
        url: "/api/ram/riskRegister/{0}"
      },
    },
    kpsr: {
      scenario: {
        save: {
          url: "/api/ram/kpsr/scenario"
        },
        delete: {
          url: "/api/ram/kpsr/scenario"
        },
      }
    },
    hazop: {
      scenario: {
        save: {
          url: "/api/ram/hazop/scenario"
        },
        delete: {
          url: "/api/ram/hazop/scenario"
        },
      }
    },
    jsa: {
      scenario: {
        save: {
          url: "/api/ram/jsa/scenario"
        },
        delete: {
          url: "/api/ram/jsa/scenario"
        },
      }
    },
    kras: {
      scenario: {
        save: {
          url: "/api/ram/kras/scenario"
        },
        delete: {
          url: "/api/ram/kras/scenario"
        },
      }
    },
    fm: {
      scenario: {
        save: {
          url: "/api/ram/4m/scenario"
        },
        delete: {
          url: "/api/ram/4m/scenario"
        },
      },
      impr: {
        inserts: {
          url: "/api/ram/4m/assess/riskReduce/imprs"
        },
        update: {
          url: "/api/ram/4m/assess/riskReduce/impr"
        },
        delete: {
          url: "/api/ram/4m/assess/riskReduce/impr/{0}"
        },
        complete: {
          url: "/api/ram/4m/assess/riskReduce/impr/complete"
        },
      },
    },
    charm: {
      scenario: {
        target: {
          url: "/api/ram/charm/result/target/scenario"
        },
        estimation: {
          url: "/api/ram/charm/estimation/scenario"
        },
        result: {
          url: "/api/ram/charm/result/scenario"
        },
        delete: {
          url: "/api/ram/charm/scenario"
        },
      }
    },
    checklist: {
      scenario: {
        save: {
          url: "/api/ram/checklist/scenario"
        },
        delete: {
          url: "/api/ram/checklist/scenario"
        },
      },
      drawNode: {
        save: {
          url: "/api/ram/checklist/assess/draw"
        },
        delete: {
          url: "/api/ram/checklist/assess/draw"
        },
      },
      master: {
        insert: {
          url: "/api/ram/checklist/master"
        },
        delete: {
          url: "/api/ram/checklist/master"
        },
      }
    },
  },
  sop: {
    lim: {
      lincense: {
        kind: {
          save: {
            url: "/api/sop/lim/licensekind"
          },
          delete: {
            url: "/api/sop/lim/licensekind"
          },
        },
        request: {
          insert: {
            url: "/api/sop/lim/license/request"
          },
          update: {
            url: "/api/sop/lim/license/request"
          },
          delete: {
            url: "/api/sop/lim/license/request/{0}"
          },
        },
        review: {
          insert: {
            url: "/api/sop/lim/license/review"
          },
          update: {
            url: "/api/sop/lim/license/review"
          },
          delete: {
            url: "/api/sop/lim/license/review/{0}"
          },
        },
        card: {
          insert: {
            url: "/api/sop/lim/license/card"
          },
          update: {
            url: "/api/sop/lim/license/card"
          },
          delete: {
            url: "/api/sop/lim/license/card/{0}"
          },
        },
        equipment: {
          insert: {
            url: "/api/sop/lim/license/equipment"
          },
          delete: {
            url: "/api/sop/lim/license/equipment"
          },
        },
        material: {
          insert: {
            url: "/api/sop/lim/license/material"
          },
          delete: {
            url: "/api/sop/lim/license/material"
          },
        },
      },
    },
    ibm: {
      improve: {
        insert: {
          url: "/api/sop/ibm/improvement",
          multi: {
            url: "/api/sop/ibm/improvements"
          },
        },
        update: {
          url: "/api/sop/ibm/improvement"
        },
        delete: {
          url: "/api/sop/ibm/improvement/{0}",
          auth: {
            url: "/api/sop/ibm/improvement/auth"
          },
        },
        approval: {
          url: "/api/sop/ibm/improvement/approval"
        },
      },
    },
    psr: {
      checkItem: {
        insert: {
          url: "/api/sop/psr/prestartup/checkItem"
        },
        update: {
          url: "/api/sop/psr/prestartup/checkItem"
        },
      },
      check: {
        insert: {
          url: "/api/sop/psr/prestartupCheck"
        },
        update: {
          url: "/api/sop/psr/prestartupCheck"
        },
        delete: {
          url: "/api/sop/psr/prestartupCheck/{0}"
        },
        complete: {
          url: "/api/sop/psr/prestartup/complete"
        },
        equipment: {
          complete: {
            url: "/api/sop/psr/prestartup/equipment/complete"
          },
        }
      },
    },
    swp: {
      workChekItem: {
        save: {
          url: "/api/sop/swp/checkItem"
        },
      },
      gas: {
        save: {
          url: "/api/sop/swp/gas"
        },
      },
      map: {
        save: {
          url: "/api/sop/swp/map"
        },
      },
      workPermit: {
        insert: {
          url: "/api/sop/swp/workPermit"
        },
        update: {
          url: "/api/sop/swp/workPermit"
        },
        delete: {
          url: "/api/sop/swp/workPermit/{0}"
        },
        approval: {
          url: "/api/sop/swp/workPermit/approval"
        },
        over: {
          url: "/api/sop/swp/workPermit/over"
        },
        cancel: {
          url: "/api/sop/swp/workPermit/cancel"
        },
        reqApproval: {
          url: "/api/sop/swp/workPermit/reqApproval"
        },
        complete: {
          url: "/api/sop/swp/workPermit/complete"
        },
      },
    },
    moc: {
      change: {
        insert: {
          url: "/api/sop/moc/moc"
        },
        update: {
          url: "/api/sop/moc/moc"
        },
        delete: {
          url: "/api/sop/moc/moc/{0}"
        },
        complete: {
          url: "/api/sop/moc/moc/complete"
        },
      },
      checklist: {
        save: {
          url: "/api/sop/moc/moc/checklist"
        },
        delete: {
          url: "/api/sop/moc/moc/checklist"
        },
      },
      review: {
        save: {
          url: "/api/sop/moc/moc/review"
        },
        delete: {
          url: "/api/sop/moc/moc/review"
        },
      },
      committee: {
        save: {
          url: "/api/sop/moc/moc/committee"
        },
        delete: {
          url: "/api/sop/moc/moc/committee"
        },
      },
      committeeReviewItem: {
        save: {
          url: "/api/sop/moc/moc/committee/reviewItem"
        },
        delete: {
          url: "/api/sop/moc/moc/committee/reviewItem"
        },
      },
      committeeHold: {
        save: {
          url: "/api/sop/moc/moc/committeeHold"
        },
        approval: {
          url: "/api/sop/moc/moc/committeeHold/approval"
        },
        keep: {
          url: "/api/sop/moc/moc/committeeHold/keep"
        },
      },
      relatedWork: {
        save: {
          url: "/api/sop/moc/moc/relatedWorks"
        },
        singleSave: {
          url: "/api/sop/moc/moc/relatedWork"
        },
        complete: {
          url: "/api/sop/moc/moc/relatedWork/complete"
        },
        delete: {
          url: "/api/sop/moc/moc/relatedWork"
        },
      },
      relatedWorkDocument: {
        save: {
          url: "/api/sop/moc/moc/relatedWorkDocument"
        },
      },
      restorationEquipment: {
        update: {
          url: "/api/sop/moc/moc/restorationEquipment"
        },
      },
      determination: {
        save: {
          url: "/api/sop/moc/determination/checklist"
        },
      }
    },
    min: {
      equipment: {
        plan: {
          daily: {
            insert: {
              url: '/api/sop/min/equipment/daily/plan'
            },
            update: {
              url: '/api/sop/min/equipment/daily/plan'
            },
            complete: {
              url: '/api/sop/min/equipment/daily/plan/complete'
            },
            delete: {
              url: '/api/sop/min/equipment/daily/plan/{0}'
            }
          },
          deterior: {
            insert: {
              url: '/api/sop/min/equipment/deterior/plan'
            },
            update: {
              url: '/api/sop/min/equipment/deterior/plan'
            },
            complete: {
              url: '/api/sop/min/equipment/deterior/plan/complete'
            },
            delete: {
              url: '/api/sop/min/equipment/deterior/plan/{0}'
            },
          },
        },
        result: {
          daily: {
            insert: {
              url: '/api/sop/min/equipment/daily/result'
            },
            update: {
              url: '/api/sop/min/equipment/daily/result'
            },
            complete: {
              url: '/api/sop/min/equipment/daily/result/complete'
            },
            delete: {
              url: '/api/sop/min/equipment/daily/result/{0}'
            },
            newItem: {
              url: '/api/sop/min/equipment/daily/new/result'
            }
          },
          deterior: {
            insert: {
              url: '/api/sop/min/equipment/deterior/result'
            },
            update: {
              url: '/api/sop/min/equipment/deterior/result'
            },
            complete: {
              url: '/api/sop/min/equipment/deterior/result/complete'
            },
            delete: {
              url: '/api/sop/min/equipment/deterior/result/{0}'
            },
            newItem: {
              url: '/api/sop/min/equipment/deterior/new/result'
            }
          }
        },
      },
      maintenance: {
        plan: {
          insert: {
            url: '/api/sop/min/maintenance/plan'
          },
          update: {
            url: '/api/sop/min/maintenance/plan'
          },
          complete: {
            url: '/api/sop/min/maintenance/plan/complete'
          },
          delete: {
            url: '/api/sop/min/maintenance/plan'
          }
        },
        result: {
          insert: {
            url: '/api/sop/min/maintenance/result'
          },
          update: {
            url: '/api/sop/min/maintenance/result'
          },
          updates: {
            url: '/api/sop/min/maintenance/results'
          },
          complete: {
            url: '/api/sop/min/maintenance/result/complete'
          },
          completes: {
            url: '/api/sop/min/maintenance/result/completes'
          },
          delete: {
            url: '/api/sop/min/maintenance/result'
          }
        }
      }
    },
    safetycheck: {
      item: {
        save: {
          url: "/api/sop/min/safetycheck/item"
        },
        delete: {
          url: "/api/sop/min/safetycheck/item"
        }
      },
      plan: {
        insert: {
          url: "/api/sop/min/safetycheck/plan"
        },
        update: {
          url: "/api/sop/min/safetycheck/plan"
        },
        delete: {
          url: "/api/sop/min/safetycheck/plan/{0}"
        },
        complete: {
          url: "/api/sop/min/safetycheck/plan/{0}"
        },
      },
      result: {
        newItem: {
          url: "/api/sop/min/safetycheck/result/new"
        }
      }
    },
    hhm: {
      hazard: {
        check: {
          insert: {
            url: "/api/sop/hhm/hazard/equipment"
          },
          update: {
            url: "/api/sop/hhm/hazard/equipment"
          },
          delete: {
            url: "/api/sop/hhm/hazard/equipment/{0}",
            auth: {
              url: "/api/sop/hhm/hazard/equipment/auth",
            }
          }
        },
        hazardHistory: {
          insert: {
            url: "/api/sop/hhm/hazard/equipment/history"
          },
          update: {
            url: "/api/sop/hhm/hazard/equipment/history"
          },
          delete: {
            url: "/api/sop/hhm/hazard/equipment/history"
          }
        },
        hazardImprove: {
          insert: {
            url: "/api/sop/hhm/hazard/equipment/improve"
          },
          update: {
            url: "/api/sop/hhm/hazard/equipment/improve"
          },
          delete: {
            url: "/api/sop/hhm/hazard/equipment/improve"
          }
        },
        master: {
          item: {
            save: {
              url: "/api/sop/hhm/hazard/item"
            },
            delete: {
              url: "/api/sop/hhm/hazard/item"
            },
          },
          type: {
            save: {
              url: "/api/sop/hhm/hazard/type"
            }
          }
        },
        focus: {
          info: {
            insert: {
              url: "/api/sop/hhm/hazard/focus/inspection"
            },
            update: {
              url: "/api/sop/hhm/hazard/focus/inspection"
            },
            complete: {
              url: "/api/sop/hhm/hazard/focus/inspection/complete"
            },
            delete: {
              url: "/api/sop/hhm/hazard/focus/inspection/{0}"
            },
          },
        },
      },
    },
    edu: {
      course: {
        insert: {
          url: "/api/sop/edu/course/info"
        },
        update: {
          url: "/api/sop/edu/course/info"
        },
        delete: {
          url: "/api/sop/edu/course/info/{0}"
        },
      },
      attendee: {
        insert: {
          url: "/api/sop/edu/course/attendee"
        },
        update: {
          url: "/api/sop/edu/course/attendee"
        },
      },
      annual: {
        insert: {
          url: "/api/sop/edu/annual/plan"
        },
        update: {
          url: "/api/sop/edu/annual/plan"
        },
        delete: {
          url: "/api/sop/edu/annual/plan"
        },
        complete: {
          url: "/api/sop/edu/annual/plan/complete"
        }
      },
      plan: {
        insert: {
          url: "/api/sop/edu/result",
          targetUser: {
            url: "/api/sop/edu/result/targetuser",
          },
          exceltargetUser: {
            url: "/api/sop/edu/result/targetuser/excel",
          },
          exceltargetUsers: {
            url: "/api/sop/edu/result/targetusers/excel",
          },
        },
        update: {
          url: "/api/sop/edu/result"
        },
        delete: {
          url: "/api/sop/edu/result/{0}",
          targetUser: {
            url: "/api/sop/edu/result/targetuser",
          }
        },
        complete: {
          url: "/api/sop/edu/result"
        },
        mail: {
          targetUser: {
            url: "/api/sop/edu/mail/targetUser"
          },
        },
      },
      result: {
        insert: {
          url: "/api/sop/edu/result/sec"
        },
        update: {
          url: "/api/sop/edu/result/sec"
        },
        complete: {
          url: "/api/sop/edu/complete/result/sec"
        },
        cancel: {
          url: "/api/sop/edu/result/cancel"
        },
      },
    },
    iim: {
      occurForm: {
        save: {
          url: "/api/sop/iim/occur/form"
        },
        delete: {
          url: "/api/sop/iim/occur/form"
        }
      },
      accident: {
        near: {
          insert: {
            url: "/api/sop/iim/accident/near"
          },
          update: {
            url: "/api/sop/iim/accident/near"
          },
          delete: {
            url: "/api/sop/iim/accident/near/{0}",
            victim: {
              url: "/api/sop/iim/accident/near/victim",
            }
          },
          complete: {
            url: "/api/sop/iim/accident/near/complete"
          },
          prevention: {
            update: {
              url: "/api/sop/iim/accident/near/prevention",
              cause: {
                url: "/api/sop/iim/accident/near/prevention/causes"
              }
            },
            delete: {
              url: "/api/sop/iim/accident/near/prevention"
            },
            complete: {
              url: "/api/sop/iim/accident/near/prevention/complete"
            },
          }
        },
        process: {
          insert: {
            url: "/api/sop/iim/accident/process",
          },
          update: {
            url: "/api/sop/iim/accident/process",
            relate: {
              url: "/api/sop/iim/accident/process/relate"
            },
            damage: {
              url: "/api/sop/iim/accident/process/damage"
            },
          },
          delete: {
            url: "/api/sop/iim/accident/process/{0}",
            chem: {
              url: "/api/sop/iim/accident/process/chem"
            },
            equip: {
              url: "/api/sop/iim/accident/process/equip"
            },
            auth: {
              url: "/api/sop/iim/accident/process/auth",
            }
          },
          complete: {
            url: "/api/sop/iim/accident/process/complete"
          },
          investigation: {
            insert: {
              url: "/api/sop/iim/accident/process/investigation",
            },
            update: {
              url: "/api/sop/iim/accident/process/investigation",
              status: {
                url: "/api/sop/iim/accident/process/investigation/status"
              }
            },
            complete: {
              url: "/api/sop/iim/accident/process/investigation/complete",
            },
            delete: {
              url: "/api/sop/iim/accident/process/investigation/{0}",
            },
          },
          prevention: {
            update: {
              url: "/api/sop/iim/accident/process/prevention",
              cause: {
                url: "/api/sop/iim/accident/process/prevention/causes"
              }
            },
            delete: {
              url: "/api/sop/iim/accident/process/prevention"
            }
          }
        }
      }
    },
    eap: {
      base: {
        insert: {
          url: "/api/sop/eap/eval/item"
        },
        delete: {
          url: "/api/sop/eap/eval/item"
        },
      },
      relation: {
        insert: {
          url: "/api/sop/eap/eval/relation"
        },
        delete: {
          url: "/api/sop/eap/eval/relation"
        },
      },
      planDocu: {
        insert: {
          url: "/api/sop/eap/plan/docu"
        },
        update: {
          url: "/api/sop/eap/plan/docu"
        },
        delete: {
          url: "/api/sop/eap/plan/docu/{0}"
        },
      },
      scenario: {
        insert: {
          url: "/api/sop/eap/plan/scenario"
        },
        update: {
          url: "/api/sop/eap/plan/scenario"
        },
        delete: {
          url: "/api/sop/eap/plan/scenario/{0}"
        },
      },
      relateAccident: {
        insert: {
          url: "/api/sop/eap/plan/relate/accident"
        },
        delete: {
          url: "/api/sop/eap/plan/relate/accident"
        },
      },
      relateMaterial: {
        insert: {
          url: "/api/sop/eap/plan/relate/material"
        },
        delete: {
          url: "/api/sop/eap/plan/relate/material"
        },
      },
      training: {
        plan: {
          insert: {
            url: "/api/sop/eap/training/plan"
          },
          update: {
            url: "/api/sop/eap/training/plan"
          },
          delete: {
            url: "/api/sop/eap/training/plan/{0}"
          },
          item: {
            save: {
              url: "/api/sop/eap/training/plan/item"
            }
          }
        },
      }
    },
    opm: {
      folder: {
        insert: {
          url: "/api/sop/opm/folder"
        },
        update: {
          url: "/api/sop/opm/folder"
        },
      },
      folderDetail: {
        insert: {
          url: "/api/sop/opm/folder/detail"
        },
        update: {
          url: "/api/sop/opm/folder/detail"
        },
        delete: {
          url: "/api/sop/opm/folder/detail/{0}"
        },
      },
      guidebook: {
        insert: {
          url: "/api/sop/opm/guidebook"
        },
        update: {
          url: "/api/sop/opm/guidebook"
        },
      },
    },
    cto: {
      basic: {
        insert: {
          url: "/api/sop/cto/info"
        },
        update: {
          url: "/api/sop/cto/info"
        },
        delete: {
          url: "/api/sop/cto/info/{0}",
          auth: {
            url: "/api/sop/cto/info/auth",
          },
        },
        complete: {
          url: "/api/sop/cto/info/complete"
        },
      },
      checklist: {
        save: {
          url: "/api/sop/cto/info/checklist"
        },
        delete: {
          url: "/api/sop/cto/info/checklist"
        },
      },
      penalty: {
        save: {
          url: "/api/sop/cto/info/penalty"
        },
        delete: {
          url: "/api/sop/cto/info/penalty"
        }
      },
      improve: {
        update: {
          url: "/api/sop/cto/info/improve"
        },
        delete: {
          url: "/api/sop/cto/info/improve",
        },
      },
      stdchecklist: {
        save: {
          url: "/api/sop/cto/std/checklist"
        },
        delete: {
          url: "/api/sop/cto/std/checklist"
        },
      },
    }
  },
  psi: {
    diagram: {
      insert: {
        url: "/api/psi/diagram"
      },
      update: {
        url: "/api/psi/diagram"
      },
      delete: {
        url: "/api/psi/diagram/{0}"
      },
    },
    document: {
      insert: {
        url: "/api/psi/document"
      },
      update: {
        url: "/api/psi/document"
      },
      delete: {
        url: "/api/psi/document/{0}"
      },
    },
    pfi: {
      power: {
        insert: {
          url: "/api/psi/pfi/power"
        },
        update: {
          url: "/api/psi/pfi/power"
        },
        delete: {
          url: "/api/psi/pfi/power/{0}"
        },
      },
      pipegasket: {
        insert: {
          url: "/api/psi/pfi/pipegasket"
        },
        update: {
          url: "/api/psi/pfi/pipegasket"
        },
        delete: {
          url: "/api/psi/pfi/pipegasket/{0}"
        },
        substance: {
          save: {
            url: "/api/psi/pfi/pipegasket/substance"
          },
          delete: {
            url: "/api/psi/pfi/pipegasket/substance"
          },
        },
      },
      device: {
        mst: {
          insert: {
            url: "/api/psi/pfi/device"
          },
          update: {
            url: "/api/psi/pfi/device"
          },
          delete: {
            url: "/api/psi/pfi/device/{0}"
          },
        },
        detail: {
          insert: {
            url: "/api/psi/pfi/devicedetail"
          },
          update: {
            url: "/api/psi/pfi/devicedetail"
          },
        },
      },
      valve: {
        insert: {
          url: "/api/psi/pfi/valve"
        },
        update: {
          url: "/api/psi/pfi/valve"
        },
        delete: {
          url: "/api/psi/pfi/valve/{0}"
        },
      },
    },
    pcd: {
      interlock: {
        insert: {
          url: "/api/psi/pcd/interlock"
        },
        update: {
          url: "/api/psi/pcd/interlock"
        },
        delete: {
          url: "/api/psi/pcd/interlock/{0}"
        },
      },
    },
    lbe: {
      fireproof: {
        insert: {
          url: "/api/psi/lbe/fireproof"
        },
        update: {
          url: "/api/psi/lbe/fireproof"
        },
        delete: {
          url: "/api/psi/lbe/fireproof/{0}"
        },
      },
      fireequip: {
        insert: {
          url: "/api/psi/lbe/fireequip"
        },
        update: {
          url: "/api/psi/lbe/fireequip"
        },
        delete: {
          url: "/api/psi/lbe/fireequip/{0}"
        },
      },
      firedetect: {
        insert: {
          url: "/api/psi/lbe/firedetect"
        },
        update: {
          url: "/api/psi/lbe/firedetect"
        },
        delete: {
          url: "/api/psi/lbe/firedetect/{0}"
        },
      },
      gasalarm: {
        insert: {
          url: "/api/psi/lbe/gasalarm"
        },
        update: {
          url: "/api/psi/lbe/gasalarm"
        },
        delete: {
          url: "/api/psi/lbe/gasalarm/{0}"
        },
      },
      localven: {
        insert: {
          url: "/api/psi/lbe/localven"
        },
        update: {
          url: "/api/psi/lbe/localven"
        },
        delete: {
          url: "/api/psi/lbe/localven/{0}"
        },
      },
      wash: {
        insert: {
          url: "/api/psi/lbe/wash"
        },
        update: {
          url: "/api/psi/lbe/wash"
        },
        delete: {
          url: "/api/psi/lbe/wash/{0}"
        },
      },
      protect: {
        insert: {
          url: "/api/psi/lbe/protect"
        },
        update: {
          url: "/api/psi/lbe/protect"
        },
        delete: {
          url: "/api/psi/lbe/protect/{0}"
        },
        item: {
          save: {
            url: "/api/psi/lbe/protectitem"
          },
          delete: {
            url: "/api/psi/lbe/protectitem"
          },
        }
      },
    },
  },
  mdm: {
    ghs: {
      nation: {
        save: '/api/mdm/ghs/nations',
      },
      mix: {
        save: '/api/mdm/ghs/mixs',
      },
      db: {
        save: '/api/mdm/ghs/dbs',
        delete: '/api/mdm/ghs/db',
      }
    },
    lawManager: {
      insert: {
        url: "/api/mdm/law/lawManager"
      },
      delete: {
        url: "/api/mdm/law/lawManager/{0}"
      }
    },
    deptmanager: {
      save: {
        url: "/api/mdm/dept/manager"
      },
      delete: {
        url: "/api/mdm/dept/manager"
      },
    },
    user: {
      insert: {
        url: "/api/mdm/hrm/user"
      },
      update: {
        url: "/api/mdm/hrm/user"
      },
      delete: {
        url: "/api/mdm/hrm/user/{0}"
      },
      changepw: {
        url: "/api/mdm/hrm/changepw"
      },
      reset: {
        url: '/api/mdm/hrm/resetpwd',
      },
      cycle: {
        url: '/api/mdm/hrm/user/cycle',
      }
    },
    dept: {
      insert: {
        url: "/api/mdm/dim/dept"
      },
      update: {
        url: "/api/mdm/dim/dept"
      },
      delete: {
        url: "/api/mdm/dim/dept/{0}"
      },
    },
    process: {
      insert: {
        url: "/api/mdm/pim/process"
      },
      update: {
        url: "/api/mdm/pim/process"
      },
      delete: {
        url: "/api/mdm/pim/process/{0}"
      },
    },
    line: {
      save: {
        url: "/api/mdm/line/line"
      },
      process: {
        insert: {
          url: "/api/mdm/line/process/line"
        },
        delete: {
          url: "/api/mdm/line/process/line"
        },
      },
    },
    place: {
      save: {
        url: "/api/mdm/line/place"
      },
      process: {
        insert: {
          url: "/api/mdm/line/process/place"
        },
        delete: {
          url: "/api/mdm/line/process/place"
        },
      },
    },
    cim: {
      vendor: {
        chgId: {
          url: "/api/mdm/cim/vendor/chgId"
        },
        insert: {
          url: "/api/mdm/cim/vendor"
        },
        update: {
          url: "/api/mdm/cim/vendor"
        },
        delete: {
          url: "/api/mdm/cim/vendor/{0}/{1}"
        },
        reset: {
          url: "/api/mdm/cim/vendorpwd"
        },
        user: {
          save: {
            url: "/api/mdm/cim/vendoruser"
          },
          delete: {
            url: "/api/mdm/cim/vendoruser"
          },
        },
        item: {
          save: {
            url: "/api/mdm/cim/vendoreval/item"
          },
          delete: {
            url: "/api/mdm/cim/vendoreval/item"
          },
        },
        type: {
          save: {
            url: "/api/mdm/cim/vendoreval/type"
          },
          delete: {
            url: "/api/mdm/cim/vendoreval/type"
          },
        },
        attach: {
          insert: {
            url: "/api/mdm/cim/vendor/attach"
          },
          update: {
            url: "/api/mdm/cim/vendor/attach"
          },
          trans: {
            url: "/api/mdm/cim/vendor/attach/trans"
          },
          delete: {
            url: "/api/mdm/cim/vendor/attach/{0}"
          },
        },
        result: {
          insert: {
            url: "/api/mdm/cim/vendoreval/result"
          },
          update: {
            url: "/api/mdm/cim/vendoreval/result"
          },
          delete: {
            url: "/api/mdm/cim/vendoreval/result/{0}"
          },
          user: {
            save: {
              url: "/api/mdm/cim/vendoreval/resultuser"
            },
          },
          item: {
            save: {
              url: "/api/mdm/cim/vendoreval/resultitem"
            },
            delete: {
              url: "/api/mdm/cim/vendoreval/resultitem"
            },
          },
        },
        council: {
          insert: {
            url: "/api/sop/vendor/council"
          },
          update: {
            url: "/api/sop/vendor/council"
          },
          delete: {
            url: "/api/sop/vendor/council/{0}"
          },
          improve: {
            update: {
              url: "/api/sop/vendor/council/improve"
            },
            delete: {
              url: "/api/sop/vendor/council/improve"
            }
          }
        }
      },
    },
    mam: {
      material: {
        save: {
          url: "/api/mdm/mam/material"
        },
        delete: {
          url: "/api/mdm/mam/material"
        },
      },
      rule: {
        insert: {
          url: "/api/mdm/mam/rule/rule"
        },
        update: {
          url: "/api/mdm/mam/rule/rule"
        },
        delete: {
          url: "/api/mdm/mam/rule/rule/{0}"
        },
        chem: {
          save: {
            url: "/api/mdm/mam/rule/chem"
          },
          delete: {
            url: "/api/mdm/mam/rule/chem"
          },
        },
      },
      chem: {
        insert: {
          url: "/api/mdm/mam/chem/material"
        },
        update: {
          url: "/api/mdm/mam/chem/material"
        },
        delete: {
          url: "/api/mdm/mam/chem/material/{0}"
        },
        dept: {
          insert: {
            url: "/api/mdm/mam/chem/dept"
          },
          delete: {
            url: "/api/mdm/mam/chem/dept"
          },
        },
        process: {
          insert: {
            url: "/api/mdm/mam/chem/process"
          },
          delete: {
            url: "/api/mdm/mam/chem/process"
          },
        },
        regulate: {
          insert: {
            url: "/api/mdm/mam/chem/regulates"
          },
          update: {
            url: "/api/mdm/mam/chem/regulate"
          },
          delete: {
            url: "/api/mdm/mam/chem/regulate"
          },
        },
        substance: {
          save: {
            url: "/api/mdm/mam/chem/substance"
          },
          delete: {
            url: "/api/mdm/mam/chem/substance"
          },
        },
        processname: {
          save: {
            url: "/api/mdm/mam/chem/processname"
          },
          delete: {
            url: "/api/mdm/mam/chem/processname"
          },
        },
        hazard: {
          insert: {
            url: "/api/mdm/mam/chem/hazard"
          },
          update: {
            url: "/api/mdm/mam/chem/hazard"
          },
          delete: {
            url: "/api/mdm/mam/chem/hazard/{0}"
          },
        }
      },
      regulation: {
        insert: {
          url: "/api/mdm/mam/regulation/item"
        },
        update: {
          url: "/api/mdm/mam/regulation/item"
        },
      }
    },
    sop: {
      job: {
        insert: {
          url: "/api/mdm/sop/sop"
        },
        update: {
          url: "/api/mdm/sop/sop"
        },
        delete: {
          url: "/api/mdm/sop/sop/{0}"
        },
        revision: {
          url: "/api/mdm/sop/sop/revision/{0}"
        },
      },
      step: {
        save: {
          url: "/api/mdm/sop/step"
        },
        delete: {
          url: "/api/mdm/sop/step"
        },
      },
      hazard: {
        save: {
          url: "/api/mdm/sop/hazard"
        },
        delete: {
          url: "/api/mdm/sop/hazard"
        },
      },
      reason: {
        save: {
          url: "/api/mdm/sop/sop"
        },
        update: {
          url: "/api/mdm/sop/sop"
        },
        delete: {
          url: "/api/mdm/sop/sop"
        },
      },
      mm: {
        insert: {
          url: "/api/mdm/sop/mm"
        },
        delete: {
          url: "/api/mdm/sop/mm"
        },
      },
      chem: {
        insert: {
          url: "/api/mdm/sop/chem"
        },
        delete: {
          url: "/api/mdm/sop/chem"
        },
      },
    },
    equipment: {
      info: {
        insert: {
          url: "/api/mdm/fim/equipment"
        },
        update: {
          url: "/api/mdm/fim/equipment"
        },
        delete: {
          url: "/api/mdm/fim/equipment"
        },
      },
      spec: {
        save: {
          url: "/api/mdm/fim/equipment/spec"
        },
        delete: {
          url: "/api/mdm/fim/equipment/spec"
        },
      },
      daily: {
        save: {
          url: "/api/mdm/fim/equipment/daily"
        },
        delete: {
          url: "/api/mdm/fim/equipment/daily"
        },
      },
      deterior: {
        save: {
          url: "/api/mdm/fim/equipment/deterior"
        },
        delete: {
          url: "/api/mdm/fim/equipment/deterior"
        },
      },
      material: {
        save: {
          url: "/api/mdm/fim/equipment/material"
        },
        delete: {
          url: "/api/mdm/fim/equipment/material"
        },
      },
      rank: {
        save: {
          url: "/api/mdm/fim/equipment/rank"
        },
      },
      class: {
        insert: {
          url: '/api/mdm/equipment/class',
        },
        update: {
          url: '/api/mdm/equipment/class',
        },
        insItem: {
          save: {
            url: '/api/mdm/equipment/class/insitem',
          },
          delete: {
            url: '/api/mdm/equipment/class/insitem',
          },
        },
        infoItem: {
          insert: {
            url: '/api/mdm/equipment/class/infoitem',
          },
          update: {
            url: '/api/mdm/equipment/class/infoitem',
          },
          delete: {
            url: '/api/mdm/equipment/class/infoitem',
          },
        },
        item: {
          daily: {
            save: {
              url: '/api/mdm/equipment/daily/item',
            },
            delete: {
              url: '/api/mdm/equipment/daily/item',
            },
          },
          deterior: {
            save: {
              url: '/api/mdm/equipment/deterior/item',
            },
            delete: {
              url: '/api/mdm/equipment/deterior/item',
            },
          },
        },
      },
      spareParts: {
        insert: {
          url: '/api/mdm/equipment/spareparts',
        },
        delete: {
          url: '/api/mdm/equipment/spareparts',
        },
      },
    },
    senior: {
      save: {
        url: '/api/mdm/senior/senior',
      },
      delete: {
        url: '/api/mdm/senior/senior',
      },
      status: {
        insert: {
          url: '/api/mdm/senior/status',
        },
        update: {
          url: '/api/mdm/senior/status',
        },
        delete: {
          url: '/api/mdm/senior/status/{0}/{1}',
        },
        rev: {
          insert: {
            url: '/api/mdm/senior/status/rev',
          }
        }
      }
    }
  },
  sai: {
    uninjury: {
      insert: {
        url: "/api/sai/uninjury"
      },
      update: {
        url: "/api/sai/uninjury"
      },
      delete: {
        url: "/api/sai/uninjury/{0}"
      },
    },
    penalty: {
      save: {
        url: "/api/sai/penalty/penalty"
      },
      delete: {
        url: "/api/sai/penalty/penalty"
      },
    },
    tbm: {
      insert: {
        url: "/api/sai/tbm/tbm",
        attendee: {
          url: "/api/sai/tbm/attendee"
        },
        equip: {
          url: "/api/sai/tbm/equip",
          result: {
            url: "/api/sai/tbm/equip/result"
          }
        },
      },
      update: {
        url: "/api/sai/tbm/tbm"
      },
      delete: {
        url: "/api/sai/tbm/tbm/{0}",
        attendee: {
          url: "/api/sai/tbm/attendee"
        },
        equip: {
          url: "/api/sai/tbm/equip",
        }
      },
      complete: {
        url: "/api/sai/tbm/tbm/complete",
      },
      preComplete: {
        url: "/api/sai/tbm/pre/complete",
      }
    },
    hazard: {
      insert: {
        url: "/api/sai/hazard/hazard",
        dept: {
          url: "api/sai/hazard/hazard/dept"
        }
      },
      update: {
        url: "/api/sai/hazard/hazard"
      },
      dept: {
        delete: {
          url: "/api/sai/hazard/hazard/dept"
        }
      },
      substance: {
        save: {
          url: "/api/sai/hazard/hazard/substance"
        },
        delete: {
          url: "/api/sai/hazard/hazard/substance"
        }
      },
      master: {
        insert: {
          url: "/api/sai/hazard/hazard/master"
        },
        update: {
          url: "/api/sai/hazard/hazard/master"
        },
      },
      type: {
        insert: {
          url: "/api/sai/hazard/hazard/dept/type"
        },
        delete: {
          url: "/api/sai/hazard/hazard/dept/type"
        },
        factor: {
          insert: {
            url: "/api/sai/hazard/hazard/dept/type/factor"
          },
          delete: {
            url: "/api/sai/hazard/hazard/dept/type/factor"
          },
        },
        user: {
          insert: {
            url: "/api/sai/hazard/hazard/dept/type/user"
          },
          delete: {
            url: "/api/sai/hazard/hazard/dept/type/user"
          },
        }
      }
    },
    workmeas: {
      plan: {
        insert: {
          url: "/api/sai/work/plan"
        },
        update: {
          url: "/api/sai/work/plan"
        },
        complete: {
          url: "/api/sai/work/plan/complete"
        },
        delete: {
          url: "/api/sai/work/plan/{0}",
        }
      },
      result: {
        insert: {
          url: "/api/sai/work/result"
        },
        update: {
          url: "/api/sai/work/result"
        },
        delete: {
          url: "/api/sai/work/result",
        },
      },
      results: {
        insert: {
          url: "/api/sai/work/results"
        }
      }
    },
    osh: {
      proceedings: {
        insert: {
          url: "/api/sai/osh/proceedings"
        },
        update: {
          url: "/api/sai/osh/proceedings"
        },
        delete: {
          url: "/api/sai/osh/proceedings/{0}"
        },
        improve: {
          update: {
            url: "/api/sai/osh/proceedings/improve"
          },
          delete: {
            url: "/api/sai/osh/proceedings/improve"
          }
        }
      }
    },
    shm: {
      policy: {
        insert: {
          url: "/api/sai/shm/policy",
          comment: {
            url: "/api/sai/shm/policy/comment",
          }
        },
        update: {
          url: "/api/sai/shm/policy",
          comment: {
            url: "/api/sai/shm/policy/comment",
          }
        },
        delete: {
          url: "/api/sai/shm/policy/{0}",
          comment: {
            url: "/api/sai/shm/policy/comment/{0}/{1}",
          }
        },
        insertlog: {
          url: "/api/sai/shm/policy/log"
        },
      }
    },
    sob: {
      board: {
        insert: {
          url: "/api/sai/sob/board"
        },
        update: {
          url: "/api/sai/sob/board"
        },
        delete: {
          url: "/api/sai/sob/board/{0}"
        },
      }
    },
    patrol: {
      itemPlace: {
        insert: {
          url: "/api/sai/patrol/result/item/place",
        },
        delete: {
          url: "/api/sai/patrol/result/item/place",
        }
      },
      linePlace: {
        insert: {
          url: "/api/sai/patrol/result/line/place",
        },
        delete: {
          url: "/api/sai/patrol/result/line/place",
        }
      },
      resultItem: {
        insert: {
          url: "/api/sai/patrol/result/item",
        },
      },
      insert: {
        url: "/api/sai/patrol/patrol",
      },
      update: {
        url: "/api/sai/patrol/patrol",
      },
      complete: {
        url: "/api/sai/patrol/patrol/complete",
      },
      delete: {
        url: "/api/sai/patrol/patrol/{0}",
      },
      place: {
        save: {
          url: "/api/sai/patrol/patrol/place",
        },
        cancel: {
          url: "/api/sai/patrol/patrol/place/cancel",
        },
      },
      improve: {
        update: {
          url: "/api/sai/patrol/patrol/improve"
        },
        delete: {
          url: "/api/sai/patrol/patrol/improve",
        },
      },
    }
  },
  hea: {
    disease: {
      save: {
        url: "/api/hea/checkup/disease"
      },
      delete: {
        url: "/api/hea/checkup/disease"
      },
    },
    examine: {
      save: {
        url: "/api/hea/checkup/examine"
      },
      delete: {
        url: "/api/hea/checkup/examine"
      },
    },
    checkup:{
      plan: {
        insert: {
          url: "/api/hea/checkup/plan"
        },
        update: {
          url: "/api/hea/checkup/plan"
        },
        delete: {
          url: "/api/hea/checkup/plan/{0}"
        },
      },
      result: {
        insert: {
          url: "/api/hea/checkup/result"
        },
        update: {
          url: "/api/hea/checkup/result"
        },
      },
      results: {
        save: {
          url: "/api/hea/checkup/results"
        },
        uploadSave: {
          url: "/api/hea/checkup/upload/results"
        }, 
        delete: {
          url: "/api/hea/checkup/results"
        },
      },
      status: {
        save: {
          url: "/api/hea/checkup/status/results"
        }
      },
      suspect: {
        user: {
          save: {
            url: "/api/hea/suspect/user"
          },
          delete: {
            url: "/api/hea/suspect/user"
          },
        },
        consult: {
          insert: {
            url: "/api/hea/suspect/consult"
          },
          update: {
            url: "/api/hea/suspect/consult"
          },
          delete: {
            url: "/api/hea/suspect/consult/{0}"
          },
          signature: {
            url: "/api/hea/suspect/consult/signature"
          }
        }
      },
    }
  },
  env: {
    danger: {
      master: {
        insert: {
          url: "/api/env/danger/master"
        },
        update: {
          url: "/api/env/danger/master"
        },
      },
      journal: {
        insert: {
          url: "/api/env/danger/journal"
        },
        update: {
          url: "/api/env/danger/journal"
        },
        delete: {
          url: "/api/env/danger/journal/{0}"
        },
      }
    },
    patrol: {
      item: {
        save: {
          url: "/api/env/patrol/item"
        },
        delete: {
          url: "/api/env/patrol/item"
        }
      },
      insert: {
        url: "/api/env/patrol/patrol"
      },
      update: {
        url: "/api/env/patrol/patrol"
      },
      delete: {
        url: "/api/env/patrol/patrol/{0}",
        auth: {
          url: "/api/env/patrol/patrol/auth"
        }
      }
    },
    facility: {
      insert: {
        url: "/api/env/hcf/facility"
      },
      update: {
        url: "/api/env/hcf/facility"
      },
    },
    facilityInspectionClass: {
      save: {
        url: "/api/env/hcf/facility/inspectionClass"
      },
    },
    facilityCheckItem: {
      save: {
        url: "/api/env/hcf/facility/checkItem"
      },
    },
    facilitySelfCheck: {
      insert: {
        url: "/api/env/hcf/facility/selfCheck"
      },
      update: {
        url: "/api/env/hcf/facility/selfCheck"
      },
      complete: {
        url: "/api/env/hcf/facility/complete/selfCheck"
      },
      delete: {
        url: "/api/env/hcf/facility/selfCheck/{0}"
      },
      signature: {
        url: "/api/env/hcf/facility/selfCheck/signature"
      }
    },
    facilitySelfCheckItem: {
      save: {
        url: "/api/env/hcf/facility/selfCheckItem"
      },
    },
    gov: {
      mst: {
        insert: {
          url: "/api/env/gov/sch/mst"
        },
        update: {
          url: "/api/env/gov/sch/mst"
        },
        delete: {
          url: "/api/env/gov/sch/mst/{0}"
        },
      },
      user: {
        insert: {
          url: "/api/env/gov/sch/user"
        },
        delete: {
          url: "/api/env/gov/sch/user"
        },
      },
      history: {
        insert: {
          url: "/api/env/gov/sch/history"
        },
        update: {
          url: "/api/env/gov/sch/history"
        },
        delete: {
          url: "/api/env/gov/sch/history/{0}"
        },
      },
    },
    water: {
      trust: {
        insert: {
          url: "/api/env/water/trust"
        },
        update: {
          url: "/api/env/water/trust"
        },
        delete: {
          url: "/api/env/water/trust/{0}"
        },
      },
    },
    waste: {
      mst: {
        insert: {
          url: "/api/env/waste/mst"
        },
        update: {
          url: "/api/env/waste/mst"
        },
      },
      volume: {
        insert: {
          url: "/api/env/waste/volume"
        },
        update: {
          url: "/api/env/waste/volume"
        },
        delete: {
          url: "/api/env/waste/volume/{0}"
        },
      },
    },
    air: {
      mst: {
        outlet: {
          insert: {
            url: "/api/env/air/mst/outlet"
          },
          update: {
            url: "/api/env/air/mst/outlet"
          },
          discharge: {
            save: {
              url: "/api/env/air/mst/outlet/discharge"
            },
            delete: {
              url: "/api/env/air/mst/outlet/discharge"
            },
          },
          discharge2: {
            save: {
              url: "/api/env/air/mst/outlet/dischargelist"
            },
            delete: {
              url: "/api/env/air/mst/outlet/dischargelist"
            },
          },
          part: {
            save: {
              url: "/api/env/air/mst/outlet/part"
            },
            delete: {
              url: "/api/env/air/mst/outlet/part"
            },
          },
          inspect: {
            save: {
              url: "/api/env/air/mst/outlet/inspect"
            },
            delete: {
              url: "/api/env/air/mst/outlet/inspect"
            },
          },
        },
        inspect: {
          save: {
            url: "/api/env/air/mst/inspect"
          },
          plant: {
            save: {
              url: "/api/env/air/mst/inspect/plant"
            },
            delete: {
              url: "/api/env/air/mst/inspect/plant"
            },
          },
        },
        history: {
          save: {
            url: "/api/env/air/mst/outlet/part/history"
          },
          delete: {
            url: "/api/env/air/mst/outlet/part/history"
          },
        }
      },
      self: {
        measure: {
          insert: {
            url: "/api/env/air/self/measure"
          },
          update: {
            url: "/api/env/air/self/measure"
          },
          delete: {
            url: "/api/env/air/self/measure/{0}"
          },
        },
        outlet: {
          save: {
            url: "/api/env/air/self/measure/outlet"
          },
        },
      }
    }
  },
  chm: {
    base: {
      dangerItem: {
        save: {
          url: "/api/chm/base/dangerItem"
        },
      }
    },
    inout: {
      save: {
        url: "/api/chm/inoutManage"
      },
      delete: {
        url: "/api/chm/inoutManage"
      },
    },
    knowhow: {
      insert: {
        url: "/api/chm/knowhow"
      },
      update: {
        url: "/api/chm/knowhow"
      },
      delete: {
        url: "/api/chm/knowhow/{0}"
      },
    },
    mail: {
      mailManager: {
        insert: {
          url: "/api/chm/mail/mailManager"
        },
        delete: {
          url: "/api/chm/mail/mailManager/{0}"
        },
      }
    }
  },
  kosha: {
    folder: {
      insert: {
        url: "/api/kosha/kosha/folder"
      },
      update: {
        url: "/api/kosha/kosha/folder"
      },
    },
    folderDetail: {
      insert: {
        url: "/api/kosha/kosha/folder/detail"
      },
      update: {
        url: "/api/kosha/kosha/folder/detail"
      },
      delete: {
        url: "/api/kosha/kosha/folder/detail/{0}"
      },
    },
    guidebook: {
      insert: {
        url: "/api/kosha/kosha/guidebook"
      },
      update: {
        url: "/api/kosha/kosha/guidebook"
      },
    },
  },
};

export default transactionConfig;
